import { Dispatch, SetStateAction, ReactElement } from 'react';
import { createOptions } from 'options';
import { Box, Button, ButtonGroup, Switch } from '@ff-it/ui';
import { canExpandFee, canAppendComment, canAltActivitName, canTransparentUnits, canAppendPONumbers } from './template';
import { facets, Template } from './types';

const facetOptions = createOptions(facets, {
  OUTLET_OR_SERVICE_CATEGORY: 'Outlet or service',
});

type TemplateProps = {
  template: Template;
  setTemplate: Dispatch<SetStateAction<Template>>;
};

export function TemplateForm({
  template: { facet, expandFees, appendComment, altActivityName, transparentUnits, appendPONumbers },
  setTemplate,
}: TemplateProps): ReactElement {
  return (
    <div className="form-inline py-2">
      <ButtonGroup>
        {facetOptions.map(({ value, label }: any) => (
          <Button
            key={value}
            variant="secondary"
            size="sm"
            active={value === facet}
            onClick={() => {
              setTemplate((template) => ({ ...template, facet: value }));
            }}
          >
            {label}
          </Button>
        ))}
      </ButtonGroup>
      {canExpandFee(facet) && (
        <Box ml="3" display="flex" gap="2">
          <Switch
            checked={expandFees}
            onChange={() => {
              setTemplate(({ expandFees, ...rest }) => ({
                ...rest,
                expandFees: !expandFees,
              }));
            }}
            id="expand-fees"
          />
          <label htmlFor="expand-fees">Expand fees</label>
        </Box>
      )}
      {canAppendPONumbers(facet) && (
        <Box ml="3" display="flex" gap="2">
          <Switch
            checked={appendPONumbers}
            onChange={() => {
              setTemplate(({ appendPONumbers, ...rest }) => ({
                ...rest,
                appendPONumbers: !appendPONumbers,
              }));
            }}
            id="append-po"
          />
          <label htmlFor="append-po">Append PO numbers</label>
        </Box>
      )}
      {canAppendComment(facet) && (
        <Box ml="3" display="flex" gap="2">
          <Switch
            checked={appendComment}
            onChange={() => {
              setTemplate(({ appendComment, ...rest }) => ({
                ...rest,
                appendComment: !appendComment,
              }));
            }}
            id="append-comment"
          />
          <label htmlFor="append-comment">Append comment</label>
        </Box>
      )}
      {canAltActivitName(facet) && (
        <Box ml="3" display="flex" gap="2">
          <Switch
            checked={altActivityName}
            onChange={() => {
              setTemplate(({ altActivityName, ...rest }) => ({
                ...rest,
                altActivityName: !altActivityName,
              }));
            }}
            id="alt-name"
          />
          <label htmlFor="alt-name">Alternative activity name</label>
        </Box>
      )}
      {canTransparentUnits(facet) && (
        <Box ml="3" display="flex" gap="2">
          <Switch
            checked={transparentUnits}
            onChange={() => {
              setTemplate(({ transparentUnits, ...rest }) => ({
                ...rest,
                transparentUnits: !transparentUnits,
              }));
            }}
            id="transp-units"
          />
          <label htmlFor="transp-units">Transparent units and quantities</label>
        </Box>
      )}
    </div>
  );
}
